/**
* 售后详情
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh; padding: 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 拒绝的提示框 需要输入拒绝原因 -->
		<el-dialog title="请输入拒绝原因" :visible.sync="dialogRejecte">
			<el-input placeholder="请输入原因" v-model="pretestResult">
				<template slot="prepend">原因:</template>
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogRejecte = false">取消拒绝</el-button>
				<el-button type="primary" @click="savePretestResult(6)">确定拒绝</el-button>
			</div>
		</el-dialog>


		<el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top" style="padding-top: 10px;">

			<el-tab-pane label="预检信息" name="0">
				<div>

					<!-- 售后信息 -->
					<el-descriptions style="padding-bottom: 20px;" direction="vertical" :column="6" border>
						<el-descriptions-item label="设备编码">{{ bluetoothAddress }}</el-descriptions-item>
						<el-descriptions-item label="设备序列号">{{ serialNumber }}</el-descriptions-item>
						<el-descriptions-item label="设备类型">{{ typeId }}</el-descriptions-item>
						<el-descriptions-item label="寄件人姓名">{{ senderName }}</el-descriptions-item>
						<el-descriptions-item label="寄件人联系方式">{{ senderContact }}</el-descriptions-item>
						<el-descriptions-item label="用户寄回地址">{{ userBackAddress }}</el-descriptions-item>
						<el-descriptions-item label="问题描述">{{ questionDesc }}</el-descriptions-item>
					</el-descriptions>

					<!-- 购买凭证 -->
					<span v-show="buyEvidenceImages.length>0" style="font-size: 14px;">购买凭证</span>
					<div class="image-list-container" style="padding-top: 5px; padding-bottom: 15px;">
						<div class="image-list">
							<div class="image-item" v-for="image in buyEvidenceImages" :key="image.id">
								<img style="width: 120px; height: 120px;" :src="image" @click="openImage(image)"
									class="image-with-background" @mouseover="changeCursor"
									@mouseleave="restoreCursor" />
							</div>
						</div>
					</div>

					<!-- 问题图片 -->
					<span v-show="questionPhotoImages.length>0" style="font-size: 14px;">设备损坏图片</span>
					<div class="image-list-container" style="padding-top: 5px; padding-bottom: 15px;">
						<div class="image-list">
							<div class="image-item" v-for="image in questionPhotoImages" :key="image.id">
								<img style="width: 120px; height: 120px;" :src="image" @click="openImage(image)"
									class="image-with-background" @mouseover="changeCursor"
									@mouseleave="restoreCursor" />
							</div>
						</div>
					</div>

					<!-- 问题视频 -->
					<span v-show="questionVideoImages.length>0" style="font-size: 14px;">设备损坏视频</span>
					<div class="image-list-container" style="margin-top: -10px; padding-bottom: 15px;">
						<div class="image-list">
							<div class="image-item" v-for="image in questionVideoImages" :key="image.id">
								<video width="280" height="158" controls>
									<source :src="image" type="video/mp4" @click="openImage(image)">
								</video>
							</div>
						</div>
					</div>

					<!-- 是否通过预检 -->
					<div v-show="afterSaleStatus==0" style="display: flex; justify-content: center; margin-top: 20px;">
						<el-button style="width: 30%; margin-right: 5%;" type="danger"
							@click="dialogRejecte = true">拒绝</el-button>
						<el-button style="width: 30%; margin-left: 5%;" type="success"
							@click="savePretestResult(5)">通过预检</el-button>
					</div>

					<!-- 通过 -->
					<div v-show="afterSalePretestStatus==5"
						style="display: flex; justify-content: center; margin-top: 20px;">
						<el-button style="width: 30%; margin-left: 5%;" type="success">预检已通过</el-button>
					</div>

					<!-- 拒绝 -->
					<div v-show="afterSalePretestStatus==6"
						style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 20px;">
						<span
							style="font-size: 14px; background-color: #999; color: #f7f7f7; padding: 5px 20px; border-radius: 10px">拒绝原因：
							{{ pretestResult }}</span>
						<el-button style="width: 30%; margin-top: 10px;" type="danger">已拒绝</el-button>
					</div>


				</div>
			</el-tab-pane>


			<el-tab-pane label="用户寄出物流追踪" name="1" :disabled="disabled01">
				<div style="padding: 20px;">
					<!-- 物流时间表 -->
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in eventsList" :key="index" :icon="activity.icon"
							:type="activity.type" :color="activity.color" :size="activity.size"
							:timestamp="activity.time_iso">
							{{activity.description}}
						</el-timeline-item>
					</el-timeline>

					<!-- 开始检修 -->
					<div v-show="afterSaleStatus==2" style="display: flex; justify-content: center; margin-top: 20px;">
						<el-button style="width: 30%; margin-left: 5%;" type="success"
							@click="sysSignForAfterSaleRecord()">开始检修</el-button>
					</div>

					<div v-show="afterSaleStatus>2" style="display: flex; justify-content: center; margin-top: 20px;">
						<el-button style="width: 30%; margin-left: 5%;" type="success">已签收</el-button>
					</div>

				</div>
			</el-tab-pane>

			<el-tab-pane label="上传检测结果" name="2" :disabled="disabled02">
				<div style="padding: 20px;">
					<!-- 上传资料 -->
					<span style="font-size: 14px;">上传检测图片</span>

					<!-- 上传图片 -->
					<el-upload v-show="afterSaleStatus==3&&paymentStatus==-1"
						style="padding-top: 10px; padding-bottom: 20px;" action="http://baidu.com/"
						list-type="picture-card" :auto-upload="false" :file-list="fileList" :on-change="handleChange">
						<i slot="default" class="el-icon-plus"></i>
						<div slot="file" slot-scope="{file}">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
									<i class="el-icon-zoom-in"></i>
								</span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</div>
					</el-upload>

					<!-- 图片展示 -->
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>

					<!-- 维修图片回显 -->
					<div class="image-list-container" style="padding-top: 5px; padding-bottom: 15px;">
						<div class="image-list">
							<div class="image-item" v-for="image in sysCheckImage" :key="image.id">
								<img style="width: 120px; height: 120px;" :src="image" @click="openImage(image)"
									class="image-with-background" @mouseover="changeCursor"
									@mouseleave="restoreCursor" />
							</div>
						</div>
					</div>

					<!-- 收费项目+金额 -->
					<el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="200px"
						class="demo-dynamic">

						<el-form-item label="总 金 额 :" prop="amount" :rules="[
						      { required: true, message: '请输入收款金额'}
						    ]">
							<el-input :disabled="!(afterSaleStatus==3&&paymentStatus==-1)"
								v-model="dynamicValidateForm.amount" autocomplete="off" @input="validateAmountInput()"
								@blur="formatToTwoDecimal('amount')" style="width: 80%;"></el-input>
						</el-form-item>

						<el-form-item v-for="(domain, index) in dynamicValidateForm.domains"
							:label="'(收费项目+收费金额): ' + (index+1)" :key="domain.key"
							:prop="'domains.' + index + '.chargeItems'"
							:rules="{ required: true, message: '收费项目不能为空', trigger: 'blur' }">

							<el-input :disabled="!(afterSaleStatus==3&&paymentStatus==-1)" v-model="domain.chargeItems"
								placeholder="请输入收费项目" style="width: 60%;"></el-input>

							<el-input :disabled="!(afterSaleStatus==3&&paymentStatus==-1)" v-model="domain.chargeAmount"
								placeholder="请输入收费金额" style="width: 15%; padding-left: 10px;"></el-input>

							<el-button v-show="afterSaleStatus==3&&paymentStatus==-1" style="margin-left: 10px;"
								@click.prevent="removeDomain(domain)">删除</el-button>

						</el-form-item>

						<el-form-item>
							<el-button v-show="afterSaleStatus==3&&paymentStatus==-1"
								@click="addDomain">新增收费项目</el-button>
						</el-form-item>

					</el-form>

					<!-- 售后问题回复 -->
					<el-input :disabled="!(afterSaleStatus==3&&paymentStatus==-1)" style="margin-bottom: 20px;"
						type="textarea" :rows="2" placeholder="售后问题回复" v-model="sysSuggest">
					</el-input>

					<!-- 是否需要更换设备编码 -->
					<div v-show="afterSaleStatus==3&&paymentStatus==-1"
						style="display: flex; align-items: center;  margin-bottom: 60px;">
						<el-switch v-model="isReplace" active-color="#13ce66" inactive-color="#999"
							active-text="是否需要更换设备编码">
						</el-switch>
						<el-input style="margin-left: 20px; width: 60%;" placeholder="请输入新的设备编码"
							v-model="newBluetoothAddress" :disabled="!isReplace">
						</el-input>
					</div>

					<div v-show="!(afterSaleStatus == 3 && paymentStatus == -1) && (newBluetoothAddress !== '' && newBluetoothAddress.length > 0)"
						style="display: flex; align-items: center; margin-bottom: 60px;">
						<span style="font-size: 14px;">新的设备编码</span>
						<el-input style="margin-left: 20px; width: 60%;" placeholder="请输入新的设备编码"
							v-model="newBluetoothAddress" :disabled="isReplace">
						</el-input>
					</div>


					<div v-show="afterSaleStatus==3&&paymentStatus==-1"
						style="display: flex; justify-content: center;  margin-bottom: 20px;">
						<el-button style="width: 60%;" type="success"
							@click="sysAfterSaleUploadCheckResult()">提交检测结果</el-button>
					</div>
					<div v-show="afterSaleStatus==3&&paymentStatus!=-1"
						style="display: flex; justify-content: center;  margin-bottom: 20px;">
						<el-button style="width: 60%;" type="success">已提交</el-button>
					</div>

					<!-- 是否需要支付 -->
					<div v-show="paymentStatus==0" style="display: flex; justify-content: center;">
						<el-button style="width: 60%;" type="warning">待支付</el-button>
					</div>
					<div v-show="paymentStatus==1" style="display: flex; justify-content: center;">
						<el-button style="width: 60%;" type="success">已支付</el-button>
					</div>
					<div v-show="paymentStatus==2" style="display: flex; justify-content: center;">
						<el-button style="width: 60%;" type="success">无需支付</el-button>
					</div>

				</div>
			</el-tab-pane>


			<el-tab-pane label="寄出设备" name="3" :disabled="disabled03">
				<div style="padding: 20px;">
					<!-- 用户的收货地址 -->
					<el-descriptions style="padding-bottom: 30px;" title="用户信息" direction="vertical" :column="6" border>
						<el-descriptions-item label="QIUI_ID">{{ userId }}</el-descriptions-item>
						<el-descriptions-item label="QIUI用户名">{{ senderName }}</el-descriptions-item>
						<el-descriptions-item label="电话号码">{{ senderContact }}</el-descriptions-item>
						<el-descriptions-item label="寄回地址" :span="2">{{ userBackAddress }}</el-descriptions-item>
					</el-descriptions>

					<!-- 寄出的物流单号 -->
					<div style="display: flex; align-items: center; margin-bottom: 20px;">
						<el-select v-show="afterSaleStatus==3" v-model="logisticsCompany" filterable
							placeholder="请选择物流公司" style="margin-right: 10px;">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item">
							</el-option>
						</el-select>
						<el-input placeholder="请输入物流单号" v-model="shipmentNumber" class="input-with-select"
							:disabled="isShipmentNumber" style="flex-grow: 1;">
						</el-input>
					</div>


					<!-- 寄出设备 -->
					<div v-show="afterSaleStatus==3" style="display: flex; justify-content: center; padding-top: 20px;">
						<el-button style="width: 60%;" type="success"
							@click="sysAfterSaleRegisterLogisticsNo()">寄出设备</el-button>
					</div>
					<div v-show="afterSaleStatus==4" style="display: flex; justify-content: center; padding-top: 20px;">
						<el-button style="width: 60%;" type="success">设备已寄出</el-button>
					</div>

				</div>
			</el-tab-pane>


			<el-tab-pane label="物流追踪" name="4" :disabled="disabled04">
				<div style="padding: 20px;">

					<!-- 物流时间表 -->
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon"
							:type="activity.type" :color="activity.color" :size="activity.size"
							:timestamp="activity.time_iso">
							{{activity.description}}
						</el-timeline-item>
					</el-timeline>


				</div>
			</el-tab-pane>

		</el-tabs>


	</div>

</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				activeName: '0', //步骤
				afterSaleStatus: '', //订单状态
				userId: '', //用户的ID

				//预检是否通过
				bluetoothAddress: '', //设备编码
				serialNumber: '', //设备序列号
				typeId: '', //设备类型
				senderName: '', //寄件人姓名
				senderContact: '', //寄件人联系方式
				userBackAddress: '', //用户寄回地址
				questionDesc: '', //问题描述
				buyEvidenceImages: [], //购买凭证
				questionPhotoImages: [], //问题图片
				questionVideoImages: [], //问题视频
				dialogRejecte: false, //拒绝提示框
				pretestResult: '', //拒绝的原因
				afterSalePretestStatus: '', //预检的状态

				//寄出的物流信息
				disabled01: false, //是否禁止点击 寄出的物流信息
				userLogisticsNo: '', //物流单号
				eventsList: [], // 物流数据

				//上传检修信息
				disabled02: false, //是否禁止点击 上传检修信息
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				keyValuePairs: {}, // 存储键值对的对象(用来存图片的)
				newKey: '', // 新键的值 框架的url
				newValue: '', // 新值的值 后台返回的url
				fileList: [], // 用于存储上传的文件列表(这里是浏览器中的缓存图片)
				dynamicValidateForm: {
					domains: [{
						chargeItems: '',
						chargeAmount: '',
					}],
					amount: ''
				},
				afterSaleCost: '', //维修的总金额
				isReplace: false, //是否更换设备编码
				newBluetoothAddress: '', //新的设备编码
				sysSuggest: '', //售后问题回复
				paymentStatus: '-1', //支付状态（0 待支付 1 已支付 2 无需支付）
				sysCheckImage: '', //维修图片

				//寄出设备
				disabled03: false, //是否禁止点击 寄出设备
				shipmentNumber: "", //物流单号
				isShipmentNumber: false, //是否填写过物流单号
				logisticsCompany: null, //物流公司
				options: [], //快递公司名称


				//物流追踪
				disabled04: false, //是否禁止点击 物流追踪
				activities: [],



			};
		},
		created() {
			window.addEventListener('keydown', this.handleGlobalKeyDown);
		},
		destroyed() {
			window.removeEventListener('keydown', this.handleGlobalKeyDown);
		},
		mounted() {
			this.id = this.$route.query.id;

			console.log('id:', this.id);

			this.getUserAfterSaleRecordDetail();
		},
		methods: {
			getUserAfterSaleRecordDetail() { //查询售后单详情
				this.loadingData = true;
				axios.get(this.$p_url + '/afterSale/H5/getUserAfterSaleRecordDetail/' + this.id, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("查询售后单详情 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态

								try {
									this.afterSaleStatus = response.data.data.afterSaleStatus; //订单状态
									this.bluetoothAddress = response.data.data.bluetoothAddress; //设备编码
									this.serialNumber = response.data.data.serialNumber; //设备序列号
									this.senderName = response.data.data.senderName; //寄件人姓名
									this.senderContact = response.data.data.senderContact; //寄件人联系方式
									this.userBackAddress = response.data.data.userBackAddress; //用户寄回地址
									this.questionDesc = response.data.data.questionDesc; //问题描述
									this.pretestResult = response.data.data.pretestResult; //预检拒绝原因
									this.afterSalePretestStatus = response.data.data.pretestStatus; //预检的状态
									this.userLogisticsNo = response.data.data.userLogisticsNo; //物流单号
									this.userId = response.data.data.userId; //用户ID
									if (response.data.data.paymentStatus != undefined) {
										this.paymentStatus = response.data.data.paymentStatus; //支付状态
									}

								} catch (error) {
									alert("查询售后单详情 获取单个数据 异常: " + error.message);
								}


								try {
									//（0 预检中 1 等待用户寄出 2 待检修 3检修中 4 检修完成)
									//disabled01 是否禁用 flase不禁用  true禁用
									if (this.afterSaleStatus == 0) {
										this.disabled01 = true;
										this.disabled02 = true;
										this.disabled03 = true;
										this.disabled04 = true;
									}

									if (this.afterSaleStatus == 1) {
										this.disabled01 = false;
										this.disabled02 = true;
										this.disabled03 = true;
										this.disabled04 = true;
									}

									if (this.afterSaleStatus == 2) {
										this.disabled01 = false;
										this.disabled02 = true;
										this.disabled03 = true;
										this.disabled04 = true;
										this.getSysAfterSaleLogisticsInfo(); //查询物流状态
									}

									if (this.afterSaleStatus == 3) { //检修中
										this.disabled01 = false;
										this.disabled02 = false;
										this.disabled03 = true;
										this.disabled04 = true;
										this.getSysAfterSaleLogisticsInfo(); //查询物流状态
										if (this.paymentStatus == 1 || this.paymentStatus == 2) {
											//支付完成 等待寄出
											this.getAllExpress(); //查询所有的快递公司
											this.disabled03 = false;
										}
									}

									if (this.afterSaleStatus == 4) {
										if (response.data.data.pretestStatus == 5) { //预检状态 5 预检通过 6 预检未通过
											this.disabled01 = false;
											this.disabled02 = false;
											this.disabled03 = false;
											this.disabled04 = false;
											this.getSysAfterSaleLogisticsInfo(); //查询物流状态
											this.isShipmentNumber = true;
											this.shipmentNumber = response.data.data.sysLogisticsNo; //寄出的物流单号
											this.getSysAfterSaleLogisticsInfo02();
										} else {
											this.disabled01 = true;
											this.disabled02 = true;
											this.disabled03 = true;
											this.disabled04 = true;
										}
									}
								} catch (error) {
									alert("查询售后单详情 按流程展示 异常: " + error.message);
								}


								try {
									//修改设备类型 1 cellmate  2pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子  9 肛塞 10三代锁 11二代钥匙盒 12尾巴 13金属锁
									if (response.data.data.typeId == 1) {
										this.typeId = "一代锁";
									}
									if (response.data.data.typeId == 2) {
										this.typeId = "梨花肛塞";
									}
									if (response.data.data.typeId == 3) {
										this.typeId = "小恶魔";
									}
									if (response.data.data.typeId == 4) {
										this.typeId = "二代锁(旧标)";
									}
									if (response.data.data.typeId == 5) {
										this.typeId = "电击拍";
									}
									if (response.data.data.typeId == 6) {
										this.typeId = "一代钥匙盒";
									}
									if (response.data.data.typeId == 7) {
										this.typeId = "二代锁(新标)";
									}
									if (response.data.data.typeId == 9) {
										this.typeId = "二代肛塞";
									}
									if (response.data.data.typeId == 10) {
										this.typeId = "三代锁";
									}
									if (response.data.data.typeId == 10) {
										this.typeId = "三代锁";
									}
									if (response.data.data.typeId == 11) {
										this.typeId = "二代钥匙盒";
									}
									if (response.data.data.typeId == 12) {
										this.typeId = "尾巴";
									}
									if (response.data.data.typeId == 13) {
										this.typeId = "金属锁";
									}

									if (response.data.data.buyEvidence != undefined && response.data.data.buyEvidence
										.length > 0) { //购买凭证

										// 如果buyEvidence不包含逗号，则直接转换为数组
										let buyEvidenceArray = response.data.data.buyEvidence.includes(',') ?
											response.data.data.buyEvidence.split(',') : [response.data.data
												.buyEvidence
											];

										this.buyEvidenceImages = buyEvidenceArray.map(image => {
											const fullPath = this.$p_urlImage + image;
											// console.log("购买凭证:", fullPath);
											return fullPath;
										});

									}

									if (response.data.data.questionPhoto != undefined && response.data.data
										.questionPhoto
										.length > 0) { //问题图片

										// 如果questionPhotoArray不包含逗号，则直接转换为数组
										let questionPhotoArray = response.data.data.questionPhoto.includes(',') ?
											response.data.data.questionPhoto.split(',') : [response.data.data
												.questionPhoto
											];

										this.questionPhotoImages = questionPhotoArray.map(image => {
											const fullPath = this.$p_urlImage + image;
											// console.log("问题图片:", fullPath);
											return fullPath;
										});

									}

									if (response.data.data.questionVideo != undefined && response.data.data
										.questionVideo
										.length > 0) { //问题视频

										// 如果questionVideoArray不包含逗号，则直接转换为数组
										let questionVideoArray = response.data.data.questionVideo.includes(',') ?
											response.data.data.questionVideo.split(',') : [response.data.data
												.questionVideo
											];

										this.questionVideoImages = questionVideoArray.map(image => {
											const fullPath = this.$p_urlImage + image;
											// console.log("问题视频:", fullPath);
											return fullPath;
										});

									}

								} catch (error) {
									alert("查询售后单详情 展示预检信息 异常: " + error.message);
								}



								try {
									this.dynamicValidateForm.amount = response.data.data.afterSaleCost; //总金额
									this.sysSuggest = response.data.data.sysSuggest; //售后问题回复

									if (response.data.data.sysCheckImage != undefined && response.data.data
										.sysCheckImage
										.length > 0) { //维修图片

										// 如果sysCheckImageArray不包含逗号，则直接转换为数组
										let sysCheckImageArray = response.data.data.sysCheckImage.includes(',') ?
											response.data.data.sysCheckImage.split(',') : [response.data.data
												.sysCheckImage
											];

										this.sysCheckImage = sysCheckImageArray.map(image => {
											const fullPath = this.$p_urlImage + image;
											// console.log("维修图片:", fullPath);
											return fullPath;
										});

									}

									const chargeAmounts = (response.data.data.afterSaleCostDetail && response.data.data
											.afterSaleCostDetail.length > 0) ?
										response.data.data.afterSaleCostDetail.split(',') : [];
									const chargeItems = (response.data.data.sysCostItem && response.data.data
											.sysCostItem
											.length > 0) ?
										response.data.data.sysCostItem.split(',') : [];

									this.dynamicValidateForm.domains = chargeItems.map((item, index) => ({
										chargeItems: item,
										chargeAmount: chargeAmounts[index] || '',
									}));

									if (response.data.data.sysChangeCodeOperate == 1) {
										this.isReplace = true;
										this.newBluetoothAddress = response.data.data.newBluetoothAddress; //新的设备编码
									} else {
										this.isReplace = false;
									}
								} catch (error) {
									alert("查询售后单详情 回显售后提交资料 异常: " + error.message);
								}


							} else {
								alert("查询售后单详情 接口失败：" + response.data);
							}
						} catch (error) {
							alert("查询售后单详情 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("查询售后单详情 请求失败：" + error);
					});
			},
			savePretestResult(pretestStatus) { //保存预检结果
				if (pretestStatus == 6 && this.pretestResult.length <= 0) {
					this.$message({
						message: '请输入拒绝原因',
						type: 'warning'
					});
					return
				}
				this.dialogRejecte = false;
				const requestData = {}; //传递的参数
				requestData.id = this.id;
				requestData.pretestStatus = pretestStatus; //预检状态 5 预检通过 6 预检未通过
				if (pretestStatus == 6) {
					requestData.pretestResult = this.pretestResult;
				}
				this.loadingData = true;
				axios.post(this.$p_url + '/afterSale/H5/savePretestResult',
						requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("保存预检结果 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.$message('操作成功');
								this.getUserAfterSaleRecordDetail();
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("保存预检结果 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			getSysAfterSaleLogisticsInfo() { //查询物流状态->用户寄出
				this.loadingData = true;
				axios.get(this.$p_url + '/afterSale/H5/getSysAfterSaleLogisticsInfo/' + this.userLogisticsNo, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("查询物流状态 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								// 清空事件列表以防止重复
								this.eventsList = [];

								try {
									// console.log("查询物流状态 打印数据：", response.data.data.accepted[0].track_info.tracking
									// 	.providers)

									const providers = response.data.data.accepted[0].track_info.tracking.providers;
									providers.forEach((provider) => {
										this.eventsList.push(...provider.events);
									});
									//console.log(this.eventsList); // 打印事件列表到控制台
								} catch (error) {
									console.log("查询物流状态 展示物流 返回的值：", error.message);
								}
							} else {
								alert("查询物流状态 接口失败：" + response.data);
							}
						} catch (error) {
							alert("查询物流状态 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("查询物流状态 请求失败：" + error);
					});
			},
			sysSignForAfterSaleRecord() { //签收用户寄出的设备
				this.loadingData = true;
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/afterSale/H5/sysSignForAfterSaleRecord/' + this.id, requestData, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("签收用户寄出的设备 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.$message('操作成功');
								this.getUserAfterSaleRecordDetail();
							} else {
								alert("签收用户寄出的设备 接口失败：" + response.data);
							}
						} catch (error) {
							alert("签收用户寄出的设备 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("签收用户寄出的设备 请求失败：" + error);
					});
			},
			sysAfterSaleUploadCheckResult() { //提交检测结果
				let values = [];
				for (let key in this.keyValuePairs) { //上传的图片
					if (this.keyValuePairs.hasOwnProperty(key)) {
						console.log(`Key: ${key}, Value: ${this.keyValuePairs[key]}`);
						values.push(this.keyValuePairs[key]);
					}
				}
				let sysCheckImage001 = values.join(',');
				console.log("提交的图片路径", sysCheckImage001);

				//总的收款金额
				console.log("总的收款金额:", this.dynamicValidateForm.amount);

				//输入的收费项目
				let chargeItemsValues = [];
				let chargeAmountValues = [];
				this.$refs['dynamicValidateForm'].validate((valid) => {
					if (valid) {
						// 遍历收费项目数组并输出每个项目的值
						this.dynamicValidateForm.domains.forEach((domain, index) => {
							console.log(`收费项目 ${index + 1}: ${domain.chargeItems},${domain.chargeAmount}`);
							chargeItemsValues.push(domain.chargeItems);
							chargeAmountValues.push(Number(domain.chargeAmount)); // 确保金额为数值类型
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				let sysCostItem001 = chargeItemsValues.join(',');
				let afterSaleCostDetail001 = chargeAmountValues.join(',');
				console.log("提交的问题", sysCostItem001);
				console.log("提交的金额", afterSaleCostDetail001);

				// 计算 chargeAmountValues 的总和
				let totalAmount = chargeAmountValues.reduce((acc, curr) => acc + curr, 0);

				//总的收款金额
				console.log("计算的总价:", totalAmount);

				// 比较总金额和输入的金额是否相等
				if (totalAmount === parseFloat(this.dynamicValidateForm.amount)) {
					console.log("总的收款金额与收费项目金额总和相等");
				} else {
					this.$message({
						message: '总的收款金额与收费项目金额总和不相等',
						type: 'warning'
					});
					return;
				}

				const requestData = {};
				requestData.id = this.id; //售后单id
				requestData.userId = this.userId; //用户ID
				if (this.isReplace) {
					if (this.newBluetoothAddress.length <= 0) {
						this.$message({
							message: '请输入新的设备编码',
							type: 'warning'
						});
						return;
					} else {
						requestData.sysChangeCodeOperate = "1"; //修改设备编码
						requestData.newBluetoothAddress = this.newBluetoothAddress; //新的设备编码
					}
				} else {
					requestData.sysChangeCodeOperate = "0"; //不修改设备编码
				}
				requestData.sysSuggest = this.sysSuggest; //售后问题回复
				requestData.sysCheckImage = sysCheckImage001; //图片
				requestData.sysCostItem = sysCostItem001; //问题
				requestData.afterSaleCostDetail = afterSaleCostDetail001; //金额
				console.log('提交检测结果传值', requestData);

				this.loadingData = true;
				axios.post(this.$p_url + '/afterSale/H5/sysAfterSaleUploadCheckResult', requestData, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("提交检测结果 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.$message('操作成功');
								this.getUserAfterSaleRecordDetail();
							} else {
								alert("提交检测结果 接口失败：" + response.data);
							}
						} catch (error) {
							alert("提交检测结果 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("提交检测结果 请求失败：" + error);
					});

			},
			getAllExpress() { //查询快递公司
				this.loadingData = true;
				axios.get(this.$p_url + '/afterSale/H5/getAllExpress', {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("查询快递公司 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.options = response.data.data.map(carrier => ({
									value: carrier.carrierCode, // 设置 value 为 carrierCode
									label: carrier.name // 设置 label 为 name
								}));
							} else {
								alert("查询快递公司 接口失败：" + response.data);
							}
						} catch (error) {
							alert("查询快递公司 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("查询快递公司 请求失败：" + error);
					});
			},
			sysAfterSaleRegisterLogisticsNo() { //寄出设备

				const requestData = {};
				if (this.shipmentNumber.length <= 0) {
					this.$message({
						message: '请填写物流单号',
						type: 'warning'
					});
					return;
				} else {
					requestData.sysLogisticsNo = this.shipmentNumber; //物流单号
				}
				if (this.logisticsCompany) {
					requestData.carrierCode = this.logisticsCompany.value; //快递公司代码
					requestData.expressName = this.logisticsCompany.label; //快递公司名称
				} else {
					this.$message({
						message: '请选择快递公司',
						type: 'warning'
					});
					return;
				}

				requestData.id = this.id;
				console.log("寄出设备 传值：", requestData);

				this.loadingData = true;
				axios.post(this.$p_url + '/afterSale/H5/sysAfterSaleRegisterLogisticsNo', requestData, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("寄出设备 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.$message('操作成功');
								this.getUserAfterSaleRecordDetail();
							} else {
								alert("寄出设备 接口失败：" + response.data);
							}
						} catch (error) {
							alert("寄出设备 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("寄出设备 请求失败：" + error);
					});
			},
			getSysAfterSaleLogisticsInfo02() { //查询物流状态->售后寄出
				this.loadingData = true;
				axios.get(this.$p_url + '/afterSale/H5/getSysAfterSaleLogisticsInfo/' + this.shipmentNumber, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("查询物流状态->售后寄出 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								try {
									const providers = response.data.data.accepted[0].track_info.tracking.providers;
									providers.forEach((provider) => {
										this.activities.push(...provider.events);
									});
								} catch (error) {
									console.log("查询物流状态->售后寄出 展示 返回的值：", error.message)
								}
							} else {
								alert("查询物流状态->售后寄出 接口失败：" + response.data);
							}
						} catch (error) {
							alert("查询物流状态->售后寄出 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert("查询物流状态->售后寄出 请求失败：" + error);
					});
			},
			handleChange(file, fileList) { // 选择文件时触发
				this.fileList = fileList;

				const formData = new FormData(); // 创建一个 FormData 对象
				formData.append("multipart", file.raw); // 将文件添加到 FormData 对象中
				axios.post(this.$p_url_shop + '/api/front/upload/qiuiUploadImage?model=user&pid=1',
						formData, { //上传图片
							withCredentials: true,
							headers: {
								'Content-Type': 'multipart/form-data', //设置为上传文件的类型
							},
						})
					.then(response => {
						console.log("上传图片的返回：", response.data)
						const state = response.data.code; // 获取状态
						if (state === 200) { // 检查状态
							this.newKey = file.url;
							this.newValue = response.data.data.url;
							this.$set(this.keyValuePairs, this.newKey, this.newValue); // 添加新的键值对
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});


			},
			handleRemove(file) { //删除图片
				console.log(file);

				const imageUrl = file.url; // 获取要删除的图片的 URL
				const imageKey = Object.keys(this.keyValuePairs).find(key => {
					const isMatch = key === imageUrl;
					return isMatch;
				});
				if (imageKey) { // 如果找到了对应的键
					const name = this.keyValuePairs[imageKey];
					console.log("对应的值:", name);

					const formData = new FormData(); // 创建一个 FormData 对象
					formData.append("imageName", name); //图片的路径
					axios.post(this.$p_url_shop + '/api/front/upload/deleteOssImage',
							formData, {
								withCredentials: true,
								headers: {
									'Content-Type': 'application/json',
									'Accept': '*/*',
								},
							})
						.then(response => {
							console.log("删除图片的返回：", response.data)
							const state = response.data.code;
							if (state === 200) {
								this.$delete(this.keyValuePairs, file.url); // 删除指定键的键值对

								// 更新 fileList，移除被删除的图片
								const index = this.fileList.indexOf(file);
								if (index !== -1) {
									this.fileList.splice(index, 1);
								}

							} else {
								alert("服务器错误:" + response.data.message)
							}
						})
						.catch(error => { // 请求失败时处理错误
							alert('请求失败:' + error);
							console.error('Error fetching data:', error);
						});
				}


			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			removeDomain(item) { //删除某个收费项目
				var index = this.dynamicValidateForm.domains.indexOf(item)
				if (index !== -1) {
					this.dynamicValidateForm.domains.splice(index, 1)
				}
			},
			addDomain() { //添加收费项目
				this.dynamicValidateForm.domains.push({
					value: '',
					key: Date.now()
				});
			},
			handleClick(tab, event) { //导航菜单的切换
				//console.log(tab, event);
			},
			openImage(url) {
				window.open(url); // 在新窗口打开图片链接
				// 或者使用以下代码在当前窗口打开图片链接
				// window.location.href = url;
			},
			changeCursor() {
				document.body.style.cursor = 'pointer'; // 当鼠标移动到图片上时，将鼠标形状改变为手形
			},
			restoreCursor() {
				document.body.style.cursor = 'default'; // 当鼠标移出图片时，恢复默认的鼠标形状
			},
			validateAmountInput() { // 这个方法在输入过程中验证和格式化输入
				let value = this.dynamicValidateForm.amount;
				// 允许输入数字和一个小数点
				if (/^\d*\.?\d*$/.test(value)) {
					this.dynamicValidateForm.amount = value;
				} else {
					// 如果输入不合法，可以设置为空字符串或者其他处理
					this.dynamicValidateForm.amount = value.slice(0, -1);
				}
			},
			formatToTwoDecimal(field) { // 这个方法在失去焦点时格式化为两位小数
				let value = this.dynamicValidateForm[field];
				if (value !== '' && value !== null) {
					// 寻找小数点的位置
					let dotIndex = value.indexOf('.');
					if (dotIndex !== -1) {
						// 截取小数点前两位
						let truncatedValue = value.slice(0, dotIndex + 3); // 加2是因为需要保留小数点本身及其后一位
						this.$set(this.dynamicValidateForm, field, truncatedValue);
					} else {
						// 没有小数点，直接使用原值
						this.$set(this.dynamicValidateForm, field, value);
					}
				}
			},
			handleGlobalKeyDown(event) {
				if (event.key === 'Enter') {
					event.preventDefault(); // 阻止默认行为
				}
			},
			//...
		},
		//...
	}
</script>

<style>
	.image-list-container {
		overflow-x: auto;
		white-space: nowrap;
	}

	.image-list {
		display: inline-block;
	}

	.image-item {
		display: inline-block;
		margin-right: 10px;
		/* 调整图片之间的间距 */
	}

	.image-item img {
		width: 150px;
		/* 调整图片宽度 */
		height: auto;
		display: block;
	}

	.image-with-background {
		background-color: #f0f0f0;
		/* 浅色背景 */
		border-radius: 5px;
		/* 5px 弧度 */
		padding: 10px;
		/* 内边距使背景更明显 */
		box-sizing: border-box;
		/* 包括内边距在内的大小计算 */
	}
</style>